import { Box, Button, Grid, styled, Typography } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_FIELDS_FLOATING_BUTTON_BACKGROUND,
  LIGHT_CONTAINER_FIELDS_FLOATING,
  LIGHT_FIELDS_FLOATING_BUTTON_BACKGROUND,
  LIGHT_TEXT_FADED_BORDER,
  PRIMARY_ICON,
} = COLORS;

export const MainCont = styled(Grid)(({ theme }) => ({
  display: 'flex',
  '& .family-profile-cont': {
    marginLeft: 'auto',
  },
  [theme.breakpoints.down(1260)]: {
    flexDirection: 'column',
    '& .family-profile-cont': {
      margin: '0 0 20px 0',
    },
  },
}));

export const MemberItemCont = styled(Box)(({ theme }) => ({
  '&:hover': {
    border: `solid 1px ${LIGHT_TEXT_FADED_BORDER}`,
  },
  transition: '300ms',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: 130,
  height: 163,
  padding: '15px 0',
  margin: '0 20px 20px 0',
  backgroundColor:
    theme.palette.type === 'dark' ? DARK_FIELDS_FLOATING_BUTTON_BACKGROUND : LIGHT_CONTAINER_FIELDS_FLOATING,
  borderStyle: 'solid',
  borderWidth: '1px',
  borderColor: 'transparent',
  borderRadius: '8px !important',
}));

export const AddMemberButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: 130,
  height: 163,
  margin: '0 20px 20px 0',
  backgroundColor:
    theme.palette.type === 'dark' ? DARK_FIELDS_FLOATING_BUTTON_BACKGROUND : LIGHT_FIELDS_FLOATING_BUTTON_BACKGROUND,
  borderStyle: 'solid',
  borderWidth: '1px',
  borderColor: 'transparent',
  borderRadius: '8px !important',

  '& path': {
    fill: PRIMARY_ICON,
  },
}));
export const MemberPic = styled('img')(() => ({
  width: 65,
  height: 89,
  borderRadius: 4,
  objectFit: 'contain',
}));
export const MemberName = styled(Typography)(() => ({
  marginTop: 4,
  fontSize: 14,
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  padding: 4,
  width: '100%',
  alignSelf: 'center',
  textAlign: 'center',
  overflow: 'hidden',
}));

export const MemberCont = styled(Box)(() => ({
  display: 'flex',
  overflow: 'auto',
  flex: 1,
  flexWrap: 'wrap',
}));

export const FamilyProfileCont = styled(Box)(() => ({
  display: 'flex',
  overflow: 'auto',
}));

export const SubmitButton = styled(Button)(() => ({
  width: '60%',
  alignSelf: 'center',
  margin: 20,
  padding: 10,
}));
